module.exports = __webpack_public_path__ + "static/media/clothes_title_en.72d34cc2.png";